// dependencies
import { List, Map } from "immutable";

const initialState = Map({
	saml: Map({
		objects: Map(),
		order: List(),
	}),
	authenticationMethods: Map({
		methods: Map(),
		order: List(),
	}),
	showSessionManager: false,
	companyEnabledAuthenticationMethods: List(),
});

export default function authentication(state = initialState, action) {
	switch (action.type) {
		case "AUTHENTICATION:GETSAMLOBJECTS@SUCCESS": {
			return state.setIn(
				["saml"],
				Map({
					objects: action.response.get("samlObjects", Map()),
					order: action.response.get("samlObjectIDs", List()),
				})
			);
		}

		case "AUTHENTICATION:UPDATESAMLOBJECT@SUCCESS": {
			const updatedSamlObject = action.response.get("samlObject");
			const samlID = updatedSamlObject.get("id");

			return state.withMutations((mutable) => {
				if (!state.getIn(["saml", "order"]).includes(samlID)) {
					mutable.updateIn(["saml", "order"], List(), (list) => list.push(samlID));
				}

				mutable.setIn(["saml", "objects", samlID], updatedSamlObject);
			});
		}

		case "AUTHENTICATION:GETMETHODS@SUCCESS":
		case "AUTHENTICATION:UPDATEMETHODS@SUCCESS": {
			return state.setIn(
				["authenticationMethods"],
				Map({
					methods: action.response.get("authenticationMap", Map()),
					order: action.response.get("authenticationTypes", List()),
				})
			);
		}

		case "AUTHENTICATION:GETENABLEDMETHODS@SUCCESS": {
			return state.setIn(
				["companyEnabledAuthenticationMethods"],
				action.response.get("companyEnabledAuthenticationMethods", List())
			);
		}

		case "AUTHENTICATION:SHOWSESSIONMANAGER": {
			return state.setIn(["showSessionManager"], true);
		}

		case "AUTHENTICATION:HIDESESSIONMANAGER": {
			return state.setIn(["showSessionManager"], false);
		}

		default:
			// never forget your default return state!
			return state;
	}
}
